import React, { useState,useEffect } from 'react';
import DatePicker from 'react-datepicker'; // Import the date picker
import 'react-datepicker/dist/react-datepicker.css'; // Import the styles
import './OrdersPage.css';
import useContentful from '../../Hooks/Contentful';


const OrdersPage = () => {
  const [filter, setFilter] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cardData, setCardData] = useState()

  const { getOrders } = useContentful();

  useEffect(() => {
      console.log("Hello orders")
   // getAuthors().then((response) => console.log("ressedagt",response));
   getOrders().then((response) => response && setCardData(response));
  },[]);


  // const dummyOrders = [
  //   {
  //     orderNumber: "123456789",
  //     clientName: "John Doe",
  //     orderDate: "2024-10-20",
  //     items: ["Item 1", "Item 2"],
  //     recipientAddress: "123 Main St, Anytown, USA",
  //     paymentStatus: "Completed",
  //     estimatedDeliveryDate: "2024-10-25",
  //     cost: 300,
  //     description: "Professional makeup brushes",
  //     quantity: 6,
  //     totalpay: 1800,
  //     paymentstatus: "Failed",
  //     size: "Medium",
  //     color: "Black",
  //     reference: "ref-123456-1234567",
  //     deliverySteps: [
  //       { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
  //       { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
  //       { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
  //       { label: "Out for Delivery", timestamp: "", completed: false },
  //       { label: "Delivered", timestamp: "", completed: false },
  //     ],
  //     pricingDetails: {
  //       subtotal: 49.99,
  //       deliveryFee: 5.00,
  //       tax: 2.50,
  //       total: 57.49,
  //     },
  //   },
  // ];

  const filteredOrders = cardData?.filter(order => {
    const orderDate = new Date(order.createdAt);
    const isWithinDateRange = (!startDate || orderDate >= startDate) && (!endDate || orderDate <= endDate);
    return (order?.reference?.includes(filter) || order?.createdAt?.includes(filter)) && isWithinDateRange;
  });

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
  };

  return (
    <div className="orders-page">
      <h2>My Orders</h2>

      <input
        type="text"
        placeholder="Filter by Order Number"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />

      <div className="date-filter">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Start Date"
          dateFormat="yyyy-MM-dd"
          className="date-input"
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          placeholderText="End Date"
          dateFormat="yyyy-MM-dd"
          className="date-input"
        />
      </div>

      <table className="orders-table">
        <thead>
          <tr>
            <th></th>
            <th>Order Number</th>
            <th>Product</th>
            <th>Client Name</th>
            <th>Client phone</th>
            <th>Order Date</th>
            <th>Payment Status</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders?.map((order,index) => (
            <tr key={order.reference}>
              <td>{index+1}</td>
              <td>{order?.reference}</td>
              <td>{order?.title}</td>
              <td>{order?.accountName}</td>
              <td>{order?.phone}</td>
              <td>{order?.createdAt}</td>
              <td className={order?.paymentstatus.toLowerCase()}>{order.paymentstatus}</td>
              <td>
                <button onClick={() => handleViewOrder(order)}>View</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedOrder && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <h3>Order Details for {selectedOrder.orderNumber}</h3>
            <p><strong>Client Name:</strong> {selectedOrder?.clientName}</p>
            <p><strong>Order Date:</strong> {selectedOrder.orderDate}</p>
            {/* <p><strong>Items:</strong> {selectedOrder.items.join(", ")}</p>
            <p><strong>Recipient Address:</strong> {selectedOrder.recipientAddress}</p>
            <p><strong>Estimated Delivery:</strong> {selectedOrder.estimatedDeliveryDate}</p> */}
            <p><strong>Cost:</strong> ZMK{selectedOrder?.cost}</p>
            <p><strong>Description:</strong> {selectedOrder?.title}</p>
            <p><strong>Quantity:</strong> {selectedOrder.quantity}</p>
            <p><strong>Total Pay:</strong> ${selectedOrder.totalpay}</p>
            <p><strong>Payment Status:</strong> {selectedOrder.paymentstatus}</p>
            <p><strong>Size:</strong> {selectedOrder.size}</p>
            <p><strong>Color:</strong> {selectedOrder.color}</p>
            <p><strong>Reference:</strong> {selectedOrder.reference}</p>
            <h4>Delivery Steps</h4>
            {/* <ul>
              {selectedOrder.deliverySteps.map((step, index) => (
                <li key={index} className={step.completed ? 'completed' : ''}>
                  {step.label} - {step.timestamp || "Pending"}
                </li>
              ))}
            </ul> */}
            <h4>Pricing Details</h4>
            {/* <p><strong>Subtotal:</strong> ${selectedOrder.pricingDetails.subtotal.toFixed(2)}</p>
            <p><strong>Delivery Fee:</strong> ${selectedOrder.pricingDetails.deliveryFee.toFixed(2)}</p>
            <p><strong>Tax:</strong> ${selectedOrder.pricingDetails.tax.toFixed(2)}</p>
            <p><strong>Total:</strong> ${selectedOrder.pricingDetails.total.toFixed(2)}</p> */}
            <p><strong>Total:</strong> ZMK{selectedOrder?.cost}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersPage;


// import React, { useState } from 'react';
// import './OrdersPage.css'; // Make sure to import your CSS file

// const OrdersPage = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   const orders = [
//     {
//       id: 1,
//       clientName: 'John Doe',
//       orderNumber: 'ORD123',
//       date: '2024-10-29',
//       paymentStatus: 'Completed',
//       deliveryStatus: 'Delivered',
//       steps: ['Order Placed', 'Shipped', 'Delivered'],
//     },
//     // Add more order objects here
//   ];

//   const filteredOrders = orders.filter(order =>
//     order.clientName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const openModal = (order) => {
//     setSelectedOrder(order);
//   };

//   const closeModal = () => {
//     setSelectedOrder(null);
//   };

//   return (
//     <div className="orders-page">
//       <h2>Order Management</h2>
      
//       <div className="date-filter">
//         <input
//           type="date"
//           className="date-input"
//           value={dateFilter.from}
//           onChange={(e) => setDateFilter({ ...dateFilter, from: e.target.value })}
//           placeholder="From Date"
//         />
//         <input
//           type="date"
//           className="date-input"
//           value={dateFilter.to}
//           onChange={(e) => setDateFilter({ ...dateFilter, to: e.target.value })}
//           placeholder="To Date"
//         />
//       </div>
      
//       <input
//         type="text"
//         placeholder="Search by Client Name"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//       />
      
//       <table className="orders-table">
//         <thead>
//           <tr>
//             <th>Client Name</th>
//             <th>Order Number</th>
//             <th>Date</th>
//             <th>Payment Status</th>
//             <th>Delivery Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredOrders.map(order => (
//             <tr key={order.id} onClick={() => openModal(order)}>
//               <td>{order.clientName}</td>
//               <td>{order.orderNumber}</td>
//               <td>{order.date}</td>
//               <td className={`payment-status ${order.paymentStatus.toLowerCase()}`}>
//                 {order.paymentStatus}
//               </td>
//               <td>{order.deliveryStatus}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
      
//       {selectedOrder && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={closeModal}>&times;</span>
//             <h3>Order Details</h3>
//             <p><strong>Client Name:</strong> {selectedOrder.clientName}</p>
//             <p><strong>Order Number:</strong> {selectedOrder.orderNumber}</p>
//             <p><strong>Date:</strong> {selectedOrder.date}</p>
//             <p><strong>Payment Status:</strong> {selectedOrder.paymentStatus}</p>
//             <p><strong>Delivery Status:</strong> {selectedOrder.deliveryStatus}</p>
            
//             <h4>Delivery Steps:</h4>
//             <ul>
//               {selectedOrder.steps.map((step, index) => (
//                 <li key={index}>{step}</li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;




// // src/components/OrdersPage.js
// import React, { useState } from 'react';
// import DatePicker from 'react-datepicker'; // Import the date picker
// import 'react-datepicker/dist/react-datepicker.css'; // Import the styles
// import './OrdersPage.css';

// const OrdersPage = () => {
//   const [filter, setFilter] = useState('');
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const dummyOrders = [
//     {
//       orderNumber: "123456789",
//       clientName: "John Doe",
//       orderDate: "2024-10-20",
//       items: ["Item 1", "Item 2"],
//       recipientAddress: "123 Main St, Anytown, USA",
//       paymentStatus: "Completed",
//       estimatedDeliveryDate: "2024-10-25",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//         { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//       pricingDetails: {
//         subtotal: 49.99,
//         deliveryFee: 5.00,
//         tax: 2.50,
//         total: 57.49,
//       },
//     },
//     {
//       orderNumber: "987654321",
//       clientName: "Jane Smith",
//       orderDate: "2024-10-22",
//       items: ["Item 3", "Item 4"],
//       recipientAddress: "456 Elm St, Othertown, USA",
//       paymentStatus: "Pending",
//       estimatedDeliveryDate: "2024-10-30",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-22 11:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "", completed: false },
//         { label: "In Transit", timestamp: "", completed: false },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//       pricingDetails: {
//         subtotal: 75.00,
//         deliveryFee: 5.00,
//         tax: 3.00,
//         total: 83.00,
//       },
//     },
//   ];

//   const filteredOrders = dummyOrders.filter(order => {
//     const orderDate = new Date(order.orderDate);
//     const isWithinDateRange = (!startDate || orderDate >= startDate) && (!endDate || orderDate <= endDate);
//     return (order.orderNumber.includes(filter) || order.orderDate.includes(filter)) && isWithinDateRange;
//   });

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//   };

//   const handleCloseModal = () => {
//     setSelectedOrder(null);
//   };

//   return (
//     <div className="orders-page">
//       <h2>My Orders</h2>

//       <input
//         type="text"
//         placeholder="Filter by Order Number"
//         value={filter}
//         onChange={(e) => setFilter(e.target.value)}
//       />

//       <div className="date-filter">
//         <DatePicker
//           selected={startDate}
//           onChange={(date) => setStartDate(date)}
//           placeholderText="Start Date"
//           dateFormat="yyyy-MM-dd"
//           className="date-input"
//         />
//         <DatePicker
//           selected={endDate}
//           onChange={(date) => setEndDate(date)}
//           placeholderText="End Date"
//           dateFormat="yyyy-MM-dd"
//           className="date-input"
//         />
//       </div>

//       <table className="orders-table">
//         <thead>
//           <tr>
//             <th>Order Number</th>
//             <th>Client Name</th>
//             <th>Order Date</th>
//             <th>Payment Status</th>
//             <th>View</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredOrders.map(order => (
//             <tr key={order.orderNumber}>
//               <td>{order.orderNumber}</td>
//               <td>{order.clientName}</td>
//               <td>{order.orderDate}</td>
//               <td className={order.paymentStatus.toLowerCase()}>{order.paymentStatus}</td>
//               <td>
//                 <button onClick={() => handleViewOrder(order)}>View</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {selectedOrder && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={handleCloseModal}>&times;</span>
//             <h3>Order Details for {selectedOrder.orderNumber}</h3>
//             <p><strong>Client Name:</strong> {selectedOrder.clientName}</p>
//             <p><strong>Order Date:</strong> {selectedOrder.orderDate}</p>
//             <p><strong>Items:</strong> {selectedOrder.items.join(", ")}</p>
//             <p><strong>Recipient Address:</strong> {selectedOrder.recipientAddress}</p>
//             <p><strong>Estimated Delivery:</strong> {selectedOrder.estimatedDeliveryDate}</p>
//             <p className={`payment-status ${selectedOrder.paymentStatus.toLowerCase()}`}>
//               <strong>Payment Status:</strong> {selectedOrder.paymentStatus}
//             </p>
//             <h4>Delivery Steps</h4>
//             <ul>
//               {selectedOrder.deliverySteps.map((step, index) => (
//                 <li key={index} className={step.completed ? 'completed' : ''}>
//                   {step.label} - {step.timestamp || "Pending"}
//                 </li>
//               ))}
//             </ul>
//             <h4>Pricing Details</h4>
//             <p><strong>Subtotal:</strong> ${selectedOrder.pricingDetails.subtotal.toFixed(2)}</p>
//             <p><strong>Delivery Fee:</strong> ${selectedOrder.pricingDetails.deliveryFee.toFixed(2)}</p>
//             <p><strong>Tax:</strong> ${selectedOrder.pricingDetails.tax.toFixed(2)}</p>
//             <p><strong>Total:</strong> ${selectedOrder.pricingDetails.total.toFixed(2)}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;


// // src/components/OrdersPage.js
// import React, { useState } from 'react';
// import './OrdersPage.css';

// const OrdersPage = () => {
//   const [filter, setFilter] = useState('');
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   const dummyOrders = [
//     {
//       orderNumber: "123456789",
//       clientName: "John Doe",
//       orderDate: "2024-10-20",
//       items: ["Item 1", "Item 2"],
//       recipientAddress: "123 Main St, Anytown, USA",
//       paymentStatus: "Completed",
//       estimatedDeliveryDate: "2024-10-25",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//         { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//       pricingDetails: {
//         subtotal: 49.99,
//         deliveryFee: 5.00,
//         tax: 2.50,
//         total: 57.49,
//       },
//     },
//     {
//       orderNumber: "987654321",
//       clientName: "Jane Smith",
//       orderDate: "2024-10-22",
//       items: ["Item 3", "Item 4"],
//       recipientAddress: "456 Elm St, Othertown, USA",
//       paymentStatus: "Pending",
//       estimatedDeliveryDate: "2024-10-30",
//       deliverySteps: [
//         { label: "Order Placed", timestamp: "2024-10-22 11:00 AM", completed: true },
//         { label: "Dispatched", timestamp: "", completed: false },
//         { label: "In Transit", timestamp: "", completed: false },
//         { label: "Out for Delivery", timestamp: "", completed: false },
//         { label: "Delivered", timestamp: "", completed: false },
//       ],
//       pricingDetails: {
//         subtotal: 75.00,
//         deliveryFee: 5.00,
//         tax: 3.00,
//         total: 83.00,
//       },
//     },
//   ];

//   const filteredOrders = dummyOrders.filter(order =>
//     order.orderNumber.includes(filter) || order.orderDate.includes(filter)
//   );

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//   };

//   const handleCloseModal = () => {
//     setSelectedOrder(null);
//   };

//   return (
//     <div className="orders-page">
//       <h2>My Orders</h2>
      
//       <input
//         type="text"
//         placeholder="Filter by Order Number or Date"
//         value={filter}
//         onChange={(e) => setFilter(e.target.value)}
//       />

//       <table className="orders-table">
//         <thead>
//           <tr>
//             <th>Order Number</th>
//             <th>Client Name</th>
//             <th>Order Date</th>
//             <th>Payment Status</th>
//             <th>View</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredOrders.map(order => (
//             <tr key={order.orderNumber}>
//               <td>{order.orderNumber}</td>
//               <td>{order.clientName}</td>
//               <td>{order.orderDate}</td>
//               <td className={order.paymentStatus.toLowerCase()}>{order.paymentStatus}</td>
//               <td>
//                 <button onClick={() => handleViewOrder(order)}>View</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {selectedOrder && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={handleCloseModal}>&times;</span>
//             <h3>Order Details for {selectedOrder.orderNumber}</h3>
//             <p><strong>Client Name:</strong> {selectedOrder.clientName}</p>
//             <p><strong>Order Date:</strong> {selectedOrder.orderDate}</p>
//             <p><strong>Items:</strong> {selectedOrder.items.join(", ")}</p>
//             <p><strong>Recipient Address:</strong> {selectedOrder.recipientAddress}</p>
//             <p><strong>Estimated Delivery:</strong> {selectedOrder.estimatedDeliveryDate}</p>
//             <p className={`payment-status ${selectedOrder.paymentStatus.toLowerCase()}`}>
//               <strong>Payment Status:</strong> {selectedOrder.paymentStatus}
//             </p>
//             <h4>Delivery Steps</h4>
//             <ul>
//               {selectedOrder.deliverySteps.map((step, index) => (
//                 <li key={index} className={step.completed ? 'completed' : ''}>
//                   {step.label} - {step.timestamp || "Pending"}
//                 </li>
//               ))}
//             </ul>
//             <h4>Pricing Details</h4>
//             <p><strong>Subtotal:</strong> ${selectedOrder.pricingDetails.subtotal.toFixed(2)}</p>
//             <p><strong>Delivery Fee:</strong> ${selectedOrder.pricingDetails.deliveryFee.toFixed(2)}</p>
//             <p><strong>Tax:</strong> ${selectedOrder.pricingDetails.tax.toFixed(2)}</p>
//             <p><strong>Total:</strong> ${selectedOrder.pricingDetails.total.toFixed(2)}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;
